import { settings } from '../settings.js';
import { beads } from '../beads.js';

const applyHuichol = bead => {
    const transform = [
        {
            angle: 45,
            x: 8,
            y: 25
        },
        {
            angle: 0,
            x: 0,
            y: 0
        },
        {
            angle: -45,
            x: -8,
            y: 25
        },
    ];
    const i = (bead.column + (bead.row % 2)) % 3;
    const t = transform[i];
    bead.setAngle(t.angle);
    bead.x += t.x;
    bead.y += t.y;
    if ((bead.column === settings.columns - 1) && (bead.row % 2 === 0)) {
        bead.ignore = true;
    }
    if ((bead.row === settings.rows - 1) && (bead.column % 3 !== 1)) {
        bead.ignore = true;
    }
};

export const huicholConfig = {
    name: 'huichol',
    displayName: 'Huichol',
    colDist: () => 32,
    rowDist: () => 50,
    offset: () => 16,
    offsetPattern: [1, 0],
    apply: () => {
        beads.arr.forEach(bead => applyHuichol(bead));
    },
    commutes: false,
    plastic: false,
    canSelectCommute: false,
    canSelectDirection: false,
    canSelectStartingBead: false,
    canSelectPanelWidth: false,
    canExportSmallDiagrams: false,
    beadFromPoint: true,
    simpleExport: true,
    splitExportImage: true,
    noCustomBeadSize: true,
    noDrag: true,
    noChangePattern: true,
    getDimensions: (myRows, myColumns, diameter, beadLength) => {
        return {
            width: myColumns * beadLength * 0.109,
            height: myRows * beadLength * 0.167
        };
    },
    disabledTools: ['Row Shift', 'Bead Mode', 'Paint', 'Star'],
    getRowsAndColumns({rows, columns}) {

        rows = (rows * 2) + 1;
        columns = (columns * 3) + 1;

        return [rows, columns];
    },
    getDisplayRowsAndColumns({rows, columns}) {
        rows = (rows - 1) / 2;
        columns = (columns - 1) / 3;

        return [rows, columns];
    },
    arrangeGrid: true
}